import type { Thunk, Action } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import type { FetchAssetParams, Contract } from '../types';
import parseStatusCode from '../../errors/parseStatusCode';

export interface ContractModel {
  fetchContracts: Thunk<ContractModel, FetchAssetParams, Injections, Promise<Contract[]>>;
  fetchContract: Thunk<ContractModel, string, Injections, Promise<Contract>>;
  contractActionStart: Action<ContractModel, void>;
  lastAction?: number;
  contracts: Record<string, Contract>;
  contractFailure: Action<ContractModel, ApplicationErrorOptions>;
  setContracts: Action<ContractModel, Contract[]>;
}

export const contractModel: ContractModel = {
  contracts: {},
  contractFailure: action((state, payload) => {
    console.error(payload);
  }),
  setContracts: action((state, payload) => {
    for (const curr of payload) {
      state.contracts[curr.contractId] = curr;
    }
  }),
  contractActionStart: action((state, payload) => {
    state.lastAction = Date.now();
  }),
  fetchContracts: thunk(async (actions, payload, { injections }) => {
    try {
      actions.contractActionStart();
      const res = await injections.assetService.fetchCarrierContracts(payload);
      actions.setContracts(res);
      return res;
    } catch (error) {
      actions.contractFailure({
        error,
        httpCode: parseStatusCode(error),
        message: 'An error occured fetching contracts',
        asNotification: true,
      });
    }
  }),
  fetchContract: thunk(async (actions, payload, { injections }) => {
    try {
      actions.contractActionStart();
      const res = await injections.assetService.fetchCarrierContract(payload);
      actions.setContracts([res]);
      return res;
    } catch (error) {
      actions.contractFailure({
        error,
        httpCode: parseStatusCode(error),
        message: 'An error occured fetching contact',
        asNotification: true,
      });
    }
  }),
};
